module.exports = __webpack_public_path__ + "static/img/1000000466_blue.10880706.jpg";